import { Col } from "antd";
import { getFormattedCurrency } from "../../../../../lib/currencyFormatter";
import { getFormattedPercentage } from "../../../../../lib/percentageFormatter";
import { useCallback, useMemo } from "react";
import dayjs from "dayjs";

type StatInfoProps = {
  origin: number;
  valueToCompare: number | undefined;
  label: string;
  date: string;
  isPercent?: boolean;
  showDigits?: boolean;
};

export const StatInfo = ({
  origin,
  valueToCompare,
  label,
  date,
  isPercent,
  showDigits = true,
}: StatInfoProps) => {
  const displayOrigiVal = useCallback(
    (val: number): string => {
      if (isPercent) {
        return showDigits ? getFormattedPercentage(val, 2) : `${val}%`;
      } else {
        return getFormattedCurrency(val, 0);
      }
    },
    [isPercent, showDigits],
  );

  const diff: number = useMemo(() => {
    if (origin === valueToCompare || valueToCompare === undefined) {
      return 0;
    } else {
      return ((origin - valueToCompare) * 100) / valueToCompare;
    }
  }, [origin, valueToCompare]);

  const diffClassName: string = useMemo(
    () =>
      `text-sm w-500 my-1 ${valueToCompare !== undefined ? (diff < 0 ? "error" : "success") : "title"}`,
    [diff, valueToCompare],
  );

  return (
    <>
      {(origin || origin === 0) && (
        <Col span={12} className="mt-6 pt-6 pr-1" flex="1 1 150px">
          <p className="mt-0 mb-1 text-md title">{label}</p>
          <h3 className="h h3 elipsis">{displayOrigiVal(origin)}</h3>
          <p className={diffClassName}>
            {valueToCompare !== undefined
              ? `${diff > 0 ? "+" : ""}${getFormattedPercentage(diff, 2)}`
              : "N/A"}
          </p>
          <p className="text-sm title w-500 elipsis my-0">
            {valueToCompare !== undefined
              ? displayOrigiVal(valueToCompare)
              : "No accounts"}{" "}
            in {dayjs(date).year()}
          </p>
        </Col>
      )}
    </>
  );
};
